import useLocalize from './useLocalize';

export default function useLocalizedState<T>(
	value: { languageID: string; text: T }[],
	setValue: (
		update: (value: { languageID: string; text: T }[]) => { languageID: string; text: T }[],
	) => void,
): [
	T | undefined,
	(value: T) => Promise<{ languageID: string; text: T }[]>,
	{ languageID: string; text: T }[],
] {
	const { language, localize } = useLocalize();

	return [
		localize(value)?.text,
		(text) =>
			new Promise((resolve) => {
				setValue((value) => {
					const result = value
						.filter(({ languageID }) => languageID !== language.id)
						.concat([
							{
								languageID: language.id,
								text,
							},
						]);
					resolve(result);
					return result;
				});
			}),
		value,
	];
}

export function useLocalizedValue<T>(
	value: { languageID: string; text: T }[],
	setValue: (value: { languageID: string; text: T }[]) => void,
	defaultValue: T,
): [
	T | undefined,
	(value: T) => Promise<{ languageID: string; text: T }[]>,
	{ languageID: string; text: T }[],
] {
	const { language, localize } = useLocalize();

	return [
		localize(value, { languageID: '', text: defaultValue })?.text,
		(text) =>
			new Promise((resolve) => {
				const result = value
					.filter(({ languageID }) => languageID !== language.id)
					.concat([
						{
							languageID: language.id,
							text,
						},
					]);
				setValue(result);
				resolve(result);
				return result;
			}),
		value,
	];
}
